import React from 'react';
import { FaFlask, FaChartBar, FaHandshake, FaFacebook, FaTwitter, FaLinkedin, FaYoutube, FaEnvelope, FaPhone, FaMapMarker, FaComments, FaUserMd, FaUserCheck, FaUniversity } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useSession } from '../context/SessionContext';
import { useNavigate } from 'react-router-dom';
import Nav from './Nav';
import SafeLink from './SafeLink';
import LanguageSelector from './LanguageSelector';
import './Landing.css';

const Landing = () => {
  const { t } = useTranslation();
  const { token, user } = useAuth();
  const { setSessionRole } = useSession();
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      {/* Usar Nav si está autenticado, sino mostrar header simple */}
      {token ? (
        <Nav />
      ) : (
        <header className="header">
          <nav className="navbar">
            <div className="nav-container">
              <SafeLink to="/" className="logo">
                <img src="/logoecseia.png" alt="Logo" className="logo-icon" />
                <span style={{ color: '#FF6600' }}>Eco</span><span style={{ color: '#ffffff' }}>ScienceInnova</span>
              </SafeLink>
              <ul className="nav-menu">
                <li><a href="#home">{t('home')}</a></li>
                <li><a href="#home">{t('comunidad')}</a></li>
                <li><a href="#membros">{t('memberships')}</a></li>
                <li><a href="#contact">{t('contact')}</a></li>
              </ul>
              <LanguageSelector />
            </div>
          </nav>
        </header>
      )}

      {/* Chat Bar */}
      <div className="chat-bar">
        <div className="chat-container">
          <FaComments className="chat-icon" />
          <input
            type="text"
            placeholder={t('chatPlaceholder')}
            className="chat-input"
          />
        </div>
      </div>

      {/* Main Section: Hero + Community Cards Integrated */}
      <section id="home" className="hero">
        <div className="hero-background"></div>
        <div className="hero-content">
          <h1 className="hero-title">
            <span style={{ color: '#FF6600' }}>Eco</span><span style={{ color: '#ffffff' }}>ScienceInnova</span>
          </h1>
          <p className="hero-subtitle">{t('tagline')}</p>

          {token ? (
            // Si está autenticado, mostrar mensaje de bienvenida y opciones de dashboard
            <div style={{
              background: 'rgba(255, 102, 0, 0.1)',
              border: '2px solid #FF6600',
              borderRadius: '12px',
              padding: '30px',
              textAlign: 'center',
              marginTop: '20px',
              maxWidth: '600px',
              margin: '20px auto'
            }}>
              <h2 style={{ color: '#fff', marginTop: 0 }}>
                ¡Bienvenido, {user?.profile?.firstName}!
              </h2>
              <p style={{ color: '#ccc', fontSize: '16px', marginBottom: '20px' }}>
                Estás autenticado y listo para acceder al portal
              </p>
              <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <SafeLink 
                  to={user?.roles?.some(r => (typeof r === 'string' ? r : r.name) === 'INVESTIGATOR') ? '/feed' : '/community-page'}
                  className="btn-outline"
                  style={{
                    background: '#FF6600',
                    color: 'white',
                    padding: '12px 30px',
                    textDecoration: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    transition: 'all 0.3s'
                  }}
                >
                  Ir a Mi Dashboard →
                </SafeLink>
              </div>
            </div>
          ) : (
            // Si no está autenticado, mostrar opciones para explorar recursos
            <div className="services-grid">
              <div className="service-card">
                <div className="service-icon"><FaUserMd /></div>
                <h3>{t('investigador')}</h3>
                <p>{t('investigadorDesc')}</p>
                <button 
                  className="btn-outline"
                  onClick={() => {
                    setSessionRole('INVESTIGATOR');
                    navigate('/researcher-library');
                  }}
                >
                  {t('investigadorBtn')}
                </button>
              </div>
              <div className="service-card">
                <div className="service-icon"><FaUserCheck /></div>
                <h3>{t('aspirante')}</h3>
                <p>{t('aspiranteDesc')}</p>
                <button 
                  className="btn-outline"
                  onClick={() => {
                    setSessionRole('INTERESTED');
                    navigate('/resources');
                  }}
                >
                  {t('aspiranteBtn')}
                </button>
              </div>
              <div className="service-card featured">
                <div className="service-icon"><FaUniversity /></div>
                <h3>{t('institucion')}</h3>
                <p>{t('institucionDesc')}</p>
                <button 
                  className="btn-outline"
                  onClick={() => {
                    setSessionRole('INSTITUTION');
                    navigate('/researcher-library');
                  }}
                >
                  {t('institucionBtn')}
                </button>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Contact & Footer Section Integrated */}
      <footer id="contact" className="footer">
        <div className="container">
          <div className="footer-balanced-row">
            <div className="footer-left-brand">
              <div className="footer-logo">
                <div className="footer-brand-badge">
                  <img src="/logoecseia.png" alt="Logo" className="logo-icon" />
                </div>
                <span style={{ color: '#FF6600' }}>Eco</span><span style={{ color: '#ffffff' }}>ScienceInnova</span>
              </div>
              <div className="social-row-inline">
                <span className="social-label">{t('followUs')}</span>
                <div className="social-icons-white">
                  <a href="#" aria-label="Facebook"><FaFacebook /></a>
                  <a href="#" aria-label="Twitter"><FaTwitter /></a>
                  <a href="#" aria-label="LinkedIn"><FaLinkedin /></a>
                  <a href="#" aria-label="YouTube"><FaYoutube /></a>
                </div>
              </div>
            </div>


            <div className="footer-right-contact">
              <div className="contact-line-item">
                <FaMapMarker className="contact-icon" />
                <span>{t('address')}</span>
              </div>
              <div className="contact-row-inline">
                <div className="contact-inline-item">
                  <FaEnvelope className="contact-icon" />
                  <span>{t('email')}</span>
                </div>
                <div className="contact-inline-item" style={{ marginLeft: '3rem' }}>
                  <FaPhone className="contact-icon" />
                  <span>{t('phone')}</span>
                </div>

              </div>
            </div>
          </div>





          <div className="footer-nav-line">
            <ul className="footer-nav-menu">
              <li><a href="#home">{t('home')}</a></li>
              <li><a href="#home">{t('comunidad')}</a></li>
              <li><a href="#">{t('aboutUs')}</a></li>
              <li><a href="#">{t('privacyPolicy')}</a></li>
              <li><a href="#membros">{t('memberships')}</a></li>
              <li><a href="#">{t('acercaDe')}</a></li>
            </ul>
          </div>

          <div className="footer-bottom">
            <p className="copyright" dangerouslySetInnerHTML={{ __html: t('copyrightDetailed') }} />
          </div>

        </div>
      </footer>
    </div>
  );
};

export default Landing;
